export type VatCalculation = {
  withoutVat: string;
  withVat: string;
  vat: string;
  vatRate: string;
};
